import React from 'react';
import { connect } from 'react-redux';
import {
  Table,
  PanelGroup,
  Panel,
} from 'react-bootstrap';

import CreateLegendaryAuctionForm from '../components/CreateLegendaryAuctionForm';
import CreateRareAuctionForm from '../components/CreateRareAuctionForm';
import CreateCommonAuctionForm from '../components/CreateCommonAuctionForm';
import ReindexForm from '../components/ReindexForm';
import WithdrawForm from '../components/WithdrawForm';
import {
  tokenGetName,
  tokenGetSymbol,
} from '../util/thunks';

class Admin extends React.Component {

  componentWillMount() {
    this.props.tokenGetName();
    this.props.tokenGetSymbol();
  }

  render() {
    return (
      <div>

        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>Token Name</th>
              <th>Token Symbol</th>
              <th>Remaining Legendary</th>
              <th>Remaining Rare</th>
              <th>Remaining Common</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                <td>{this.props.token.name}</td>
                <td>{this.props.token.symbol}</td>
                <td>?</td>
                <td>?</td>
                <td>?</td>
              </tr>
          </tbody>
        </Table>

        <PanelGroup accordion id="admin-panel-group-create-legendary-auction">
          <Panel eventKey="1">
            <Panel.Heading>
              <Panel.Title toggle>Create Legendary Token Auction</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <CreateLegendaryAuctionForm />
            </Panel.Body>
          </Panel>
        </PanelGroup>

        <PanelGroup accordion id="admin-panel-group-create-rare-auction">
          <Panel eventKey="2">
            <Panel.Heading>
              <Panel.Title toggle>Create Rare Token Auction</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <CreateRareAuctionForm />
            </Panel.Body>
          </Panel>
        </PanelGroup>

        <PanelGroup accordion id="admin-panel-group-create-common-auction">
          <Panel eventKey="3">
            <Panel.Heading>
              <Panel.Title toggle>Create Common Token Auction</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <CreateCommonAuctionForm />
            </Panel.Body>
          </Panel>
        </PanelGroup>

        <PanelGroup accordion id="admin-panel-group-reindex">
          <Panel eventKey="4">
            <Panel.Heading>
              <Panel.Title toggle>Utilities</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <ReindexForm />
              <WithdrawForm />
            </Panel.Body>
          </Panel>
        </PanelGroup>

      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    token: state.token,
  };
};

const mapDispatchToProps = (dispatch) => ({
  tokenGetName: () => {
    return dispatch(tokenGetName());
  },
  tokenGetSymbol: () => {
    return dispatch(tokenGetSymbol());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js